import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-component-vx-card',
  templateUrl: './component-vx-card.component.html',
  styleUrls: ['./component-vx-card.component.scss']
})
export class ComponentVxCardComponent  {

  @Input() data: any;
  @Input() index: string;
  @Input() stickerid: string;
  @Input() light: boolean;
  // element: any;
  // class: string;

  // ngAfterViewInit(): void {
  //   this.element = document.getElementById(this.stickerid + this.index);
  //   if(this.element){
  //     this.checktag();
  //   }
  // }
  // checktag(): void {
  //     if (this.data.tag.includes('New')) {
  //         this.class = 'vx-tag vx-sup-tag vx-gradient-tag';
  //     } else if (this.data.tag === 'VeExpress') {
  //         this.class = 'vx-tag vx-sup-tag vx-system-tag';
  //     } else if (this.data.tag === 'VeSion') {
  //         this.class = 'vx-tag vx-sup-tag vx-system-tag';
  //     } else if (this.data.tag === '') {
  //       // console.log('empty tag', this.index);
  //     } else {
  //         this.class = 'vx-tag vx-sup-tag';
  //     }
  // }

  get tagClass(): string {
    if (this.data.tag && this.data.tag.includes('New')) {
      return 'vx-tag vx-sup-tag vx-gradient-tag';
    } else if (['VeExpress', 'VeSion'].includes(this.data.tag)) {
      return 'vx-tag vx-sup-tag vx-system-tag';
    } else {
      if (this.data.tag === '' || this.data.tag === undefined) {
        return '';
      }
      return 'vx-tag vx-sup-tag';
    }
  }



}
